import { render, staticRenderFns } from "./SkillsChips.vue?vue&type=template&id=99495d8c&scoped=true"
import script from "./SkillsChips.vue?vue&type=script&lang=ts"
export * from "./SkillsChips.vue?vue&type=script&lang=ts"
import style0 from "./SkillsChips.vue?vue&type=style&index=0&id=99495d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99495d8c",
  null
  
)

export default component.exports